import React, { useEffect, useState } from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import UserCard from '../../UserCard';

const getDisplayName = (item) => `${item?.user.lastName || ''} ${item?.user.firstName || ''} ${item?.user.middleName || ''}`;

export default function Participants({ title, data, userRoles,acceptedData, dataStatus }) {
    const convertToItemUserCard  = (item) => {
        if(item) {
            item.displayName = item?.displayName || getDisplayName(item)
            item.email = item?.email || item?.user.email
        }
        return item;
    }

  return (
    <div className="read-only">
      <Card className="mb-4">
        <Card.Header as={Card.Title} className="p-4">{title}</Card.Header>
        <Card.Body className="p-4">
          <Row>
            {data.map((item, index) => {
                let acceptedItem = acceptedData?.find(x=>x?.role === item.role)
                item = convertToItemUserCard(item);
                acceptedItem = convertToItemUserCard(acceptedItem);
                return <Col md={4} className="mb-4" key={index}>
                    <UserCard
                        passportStatus={dataStatus}
                        acceptedItem={acceptedItem}
                        item={item}
                        key={index}
                        displayName={item.displayName}
                        role={userRoles[item.role]}
                        // tel='+7 (909) 99-90-90'
                        job={item.post}
                        email={item.email}
                    />
                </Col>
            })}
          </Row>
        </Card.Body>
      </Card>
    </div>
  );
}
